import {Contact, Disposal, SendMailQueryVariables} from "./API";
import {pickUpTimeToStringLong, selectedCountryToString} from "./wizard/components/steps/contact/SelectOptions";
import {
    API,
    graphqlOperation,
    I18n
} from "aws-amplify";
import {GraphQLResult} from "@aws-amplify/api/lib-esm/types";
import awsconfig from "./aws-exports";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "./redux/rootReducer";
import React, {useState} from "react";
import {EnhancedDisposal} from "./wizard/state/disposalSlice";
import moment from "moment";
import {sendMail} from "./graphql/queries";
import {CircularProgress, Dialog, DialogContent, DialogContentText, DialogTitle, useTheme} from "@material-ui/core";
import {isEmpty} from "lodash";
import {toggleJourneySuccessful} from "./wizard/state/navigationSlice";
import {googleAnalyticsTrackError} from "./googleHook";

export const toApiDisposal = (ed: EnhancedDisposal): Disposal => ({
    type: ed.type,
    materials: ed.materials,
    comments: ed.comments,
    image: ed.image,
    brand: ed.brand ? ed.brand.unknown ? I18n.get("common").unknown : ed.brand.value : undefined,
    model: ed.model ? ed.model.unknown ? I18n.get("common").unknown : ed.model.value : undefined,
    referenceNumber: ed.referenceNumber ? ed.referenceNumber.unknown ? I18n.get("common").unknown : ed.referenceNumber.value : undefined
});

export const configureApi = () => API.configure(awsconfig);

export function useApi() {

    const dispatch = useDispatch();
    const theme = useTheme();
    const {contact, disposal: {disposals}} = useSelector((state: RootState) => state);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<[object] | null>(null);

    const resetError = () => setError(null);

    const renderLoading = () => (isLoading ?
        <CircularProgress variant="indeterminate" style={{color: theme.palette.text.primary}}/> : null);

    const renderError = () => (
        <Dialog
            open={true}
            onClose={resetError}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Verbindungsfehler"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );

    const sendLead = () => {
        setIsLoading(true);

        const contactPayload: Contact = {
            ...contact,
            address: {
                ...contact.address,
                country: selectedCountryToString(Number(contact.address.country))
            },
            birthday: moment(contact.birthday).format(),
            paymentType: contact.paymentType,
            pickUp: contact.pickUp ? {
                ...contact.pickUp,
                date: contact.pickUp ? moment(contact.pickUp.date).format() : "",
                weight: contact.pickUp ? contact.pickUp.weight : 500,
                timespan: contact.pickUp ? pickUpTimeToStringLong(Number(contact.pickUp.timespan)) : ""
            } : null
        };

        const payload: SendMailQueryVariables = {
            contact: contactPayload,
            disposals: disposals.map(disposal => toApiDisposal(disposal))
        };

        (API.graphql(graphqlOperation(sendMail, payload)) as Promise<GraphQLResult>)
            .then(() => {
                setIsLoading(false);
                setError(null);
                dispatch(toggleJourneySuccessful());
            })
            .catch(err => {
                googleAnalyticsTrackError(err);
                setIsLoading(false);
                setError(err.errors);
            });
    };

    return {sendLead, ApiProgress: isEmpty(error) ? renderLoading : renderError};
}
